export const getPublicHolidays = async () => {
  const response = await fetch('https://calendrier.api.gouv.fr/jours-feries/metropole.json')
  return response.json()
}
export const getSchoolHolidays = async (schoolYear) => {
  const response = await fetch(`https://data.education.gouv.fr/api/explore/v2.1/catalog/datasets/fr-en-calendrier-scolaire/records?where=location%3D%22Cr%C3%A9teil%22%20and%20annee_scolaire%3D%22${schoolYear}%22&order_by=start_date%20desc&limit=100&offset=0&exclude=population%3AEnseignants&timezone=UTC&include_links=false&include_app_metas=false`)
  return response.json()
}
